import { Component, OnInit, OnDestroy, Input, ViewChild, ElementRef } from '@angular/core';
import { MenuService } from '../../../../services/menu.service';
import { ConfigService } from '../../../../services/config.service';
import { DataIoService } from '../../../../services/data-io.service';
import { TranslationService } from '../../../../services/translation.service';
import { LoadinganimationComponent } from '../loadinganimation/loadinganimation.component';
import { MenuNode } from '../../../../classes';
import { ValueChangedConfirmation } from '../../../../classes/ValueChangedConfirmation';
import { EnabledNodesPipe } from '../../../../pipes/enabled-nodes.pipe';
import { TimeFrame, TimeFrameManager } from '../../../../classes';
@Component({
    selector: 'app-day-planner-overview',
    templateUrl: './day-planner-overview.component.html',
    styleUrls: ['./day-planner-overview.component.scss'],
    standalone: false
})
export class DayPlannerOverviewComponent implements OnInit {
    @Input('debug') debug:boolean = false;
    table:string = 'heating';
    _initTop : number = 42.91666667;
    _top :number = 42.91666667;
    //_elementHeight :number = 12.8;
    _elementHeight :number = 11;
    opacity_begin:number;
    timeslotLimit = 12;
    opacity_end:number;
    top:string;
    titleopacity:number =1;
    mode:string;
    timeframes: Array<TimeFrame>;
    eventSubscription:any;
    menuElements :Array<MenuNode>;
    currentElement:MenuNode; // das element, unter dem das menü liegt.
    title:string;
    subtitle:string;
    submenuOpenOn:MenuNode;
    template_parameters:Array<string>;
    day:number=0;
    zone:string="";
    ignore:string="";

    days = [ 
      'DELIGHT_WEEKLY_PLANNER_MONDAY',
      'DELIGHT_WEEKLY_PLANNER_TUESDAY',
      'DELIGHT_WEEKLY_PLANNER_WEDNESDAY',
      'DELIGHT_WEEKLY_PLANNER_THURSDAY',
      'DELIGHT_WEEKLY_PLANNER_FRIDAY',
      'DELIGHT_WEEKLY_PLANNER_SATURDAY',
      'DELIGHT_WEEKLY_PLANNER_SUNDAY'
    ];


    getTitle(){
    	return this.translator.tr( this.days[this.day] );
    }

    debugOut(msg:string){
        if(this.debug){
            console.log("DayPlannerOverview: "+msg);
        }
    }

    constructor(
        private menuService: MenuService, 
        private ioService: DataIoService, 
        private config: ConfigService,
        private enabledNodes: EnabledNodesPipe,
        private translator: TranslationService,
        ) { 
    }


    hasNextMenuItem(){
    	return (this.menuElements.indexOf(this.currentElement) <  this.menuElements.length-1);
    }

    calculateTop():void{
        let factor = this.elementsAbove(this.currentElement);
        this._top = this._initTop - (this._elementHeight * factor); 
        this.debugOut("Elements above: "+factor);
    }
    
    elementsAbove(element:MenuNode){
    	return this.menuElements.indexOf(element);
    }
    
    selectNextMenuItem(){
       this.currentElement = this.menuElements[ this.menuElements.indexOf(this.currentElement)+1];
       return;
    }

    hasPreviousMenuItem(){
        return (this.menuElements.indexOf(this.currentElement) >0)

    }
    selectPreviousMenuItem(){
    	this.currentElement = this.menuElements[ this.menuElements.indexOf(this.currentElement)-1];
    }

    pans=0;
    panSkip=2;
    eventHandler(event){
        this.debugOut("MenuElements:");
        for(let el of this.menuElements){
            this.debugOut("["+el.getTitle()+"]");
        }
    	switch(event){
    		case 'back':{
    			this.menuService.hierarchyUp();
    			return;
    		}
            case 'pandown':{
                this.pans=(++this.pans%this.panSkip);
                if(this.pans != 0){
                    return;
                }
            }
            case 'down':{
                this.debugOut("Down pressed.");
                if(this.hasNextMenuItem()){
                    this.selectNextMenuItem();                    
                }

                break;
            }
            case 'panup':{
                this.pans=(++this.pans%this.panSkip);
                if(this.pans != 0){
                    return;
                }
            }
            case 'up':{
                if(this.hasPreviousMenuItem()){
                    this.selectPreviousMenuItem();
                }
                break;
            }
            case 'confirm':{
            	switch(this.currentElement.getType()){
            		case 'menu':{
            			this.debugOut("Going to current element: ");
            			this.debugOut(JSON.stringify(this.currentElement.toDebugMap()));
            			this.menuService.goto(this.currentElement);
            			return;
            		}
            		case 'deleteall':{
                        this.debugOut("Deleting all..");
                        let target = this.menuService.getCurrentNode();
                        target.setTarget('goto:'+target.getIdentifier());
                        //let confirmation = new ValueChangedConfirmation('','0','1',target);
                        let clearFrames = ()=>{this.ioService.deviceInfo().getZoneById(parseInt(this.zone)).getTimeFrameManager(this.table).clearDay(this.day);};
                        this.debugOut("Creating confirmation toast.");
                        let confirmationToast = new MenuNode({
                            "title": "DELIGHT_CONFIRMATION_DELETE_TIMESLOTS_TITLE",
                            "buttons": "confirm,back,menu",
                            "template": "toast",
                            "template_parameter": "darkText3",
                            "back":'goto:'+this.menuService.getCurrentNode().getIdentifier(),
                            "icon": "iconOperationTime",
                            "onConfirm":'clear.timeframes['+this.table+','+this.zone+","+this.day+"]",
                            "target": 'goto:'+this.menuService.getCurrentNode().getIdentifier(),
                            "text": [
                                "DELIGHT_TIME_WINDOW_DELETE_ALL_TIMESLOTS_MESSAGE_1",
                                "DELIGHT_TIME_WINDOW_DELETE_ALL_TIMESLOTS_MESSAGE_2",
                                "DELIGHT_TIME_WINDOW_DELETE_ALL_TIMESLOTS_MESSAGE_2"
                              ]
                            });

                        this.debugOut("going to confirmation Toast");
                        this.menuService.goto(confirmationToast);
                        return;
            			break;
            		}
            		case 'editframe':{
                        this.debugOut("Editing "+this.currentElement.getIdentifier());
            			let element = this.menuService.currentNode.findFromRoot('edit-time-frame');
            			if(element){
	            			element.set('zone',this.zone);
	            			element.set('day',this.day);
	            			element.set('id',this.currentElement.getIdentifier());
                            element.set('table',this.table);
                            element.set('mode','edit');
                            element.set('ignore',this.ignore);
	            			element.setTarget("goto:"+this.menuService.getCurrentNode().getIdentifier());
	            			this.menuService.goto(element);
            			}else{
            				this.debugOut("Cannot go to null.");
            			}
                        break;
            		}

                    case 'addframe':{
                        let element = this.menuService.currentNode.findFromRoot('edit-time-frame');
                        if(element){
                            element.set('zone',this.zone);
                            element.set('day',this.day);
                            element.set('id',this.currentElement.getIdentifier());
                            element.set('table',this.table);
                            element.set('mode','add');
                            element.set('ignore',this.ignore);
                            element.setTarget("goto:"+this.menuService.getCurrentNode().getIdentifier());
                            this.menuService.goto(element);
                        }else{
                            this.debugOut("Cannot go to null.");
                        }
                    }
            	}
            }
    	}
     	this.calculateTop();

        this.top = this._top+"%"; 
        this.applyOpacity();
    }

    applyOpacity(){
        if((this._top) <= (this.opacity_end)){
            this.titleopacity=0;
            return;
        }
        if((this._top) >= (this.opacity_begin)){
            this.titleopacity=1;
            return;
        }

        this.titleopacity = 1.0- (((this._top) - (this.opacity_begin))/((this.opacity_end) - (this.opacity_begin)));
        if(this.titleopacity < 0){
            this.titleopacity=0;
        }
    }

    ngOnInit() {

        this.top = this._top+"%";
        this.opacity_begin=this._top-0.5*this._elementHeight;
        this.opacity_end=this._top-2*this._elementHeight;
        this.ignore = this.menuService.getCurrentNode().get('ignore');
        this.day = parseInt(this.menuService.getCurrentNode().get('day'));
    	this.zone = (this.menuService.getCurrentNode().get('zone'));
        this.table = (this.menuService.getCurrentNode().get('table'));
        if(['heating','cooling'].includes(this.table)){
            this.timeslotLimit = 12;
        }else{
            this.timeslotLimit = 3;
        }
        this.eventSubscription = this.ioService.inputs.events$.subscribe(
            (event)=>{this.eventHandler(event);}
        );
        this.debugOut("Showing table for Zone " + this.zone+ "("+this.table+") on day "+this.day);
        this.reinitMenu();

    }

    reinitMenu(){
    	this.menuElements = new Array<MenuNode>();
        this.debugOut("Getting timeframe manager for "+this.zone);
        let manager = this.ioService.deviceInfo().getZoneById(parseInt(this.zone)).getTimeFrameManager(this.table);
        this.timeframes = manager.getTimeFrames(this.day);
        let hasTimeframes = false;
        let node = new MenuNode();
        for(let frame of this.timeframes){
            if(this.menuService.getCurrentNode().isDescendantOf('schaltuhr_heizen')){
                frame.setIgnoreTemperature(true);
            }
        	hasTimeframes=true;
            this.debugOut("Showing "+frame.getId());
        	node = new MenuNode();
            node.setName(frame.toString());
        	node.setTitle(frame.toString());
        	node.setType('editframe');
        	node.setIdentifier(""+frame.id);
        	this.menuElements.push(node);
        }

        if(this.timeframes.length < this.timeslotLimit){
            node = new MenuNode();
            node.setName('Zeitfenster hinzufügen');
            node.setTitle('DELIGHT_TIME_WINDOW_ADD_TIMESLOT');
            node.setType('addframe');
            this.menuElements.push(node);
        }
        
        if(hasTimeframes){
	        node = new MenuNode();
	        node.setName('Alle Zeitfenster löschen');
	        node.setTitle('DELIGHT_TIME_WINDOW_DELETE_ALL_TIMESLOT');
	        node.setType('deleteall');
            this.menuElements.push(node);
        }
        node = new MenuNode();
        node.setName('Einstellungen kopieren auf...');
        node.setTitle('DELIGHT_TIME_WINDOW_COPY_SETTING');
        node.setType('menu');
        node.setButtons('back,slider,confirm');
        node.setTarget('goto:'+this.menuService.getCurrentNode().getIdentifier());
        node.setTemplateParameters('nobox');
        node.setTemplate('menu');
        
        for(let dayIdx in this.days){
        	if(parseInt(dayIdx) == this.day){
        		continue;
        	}
        	let subnode = new MenuNode();
        	subnode.setName(this.days[dayIdx]);
        	subnode.setTitle(this.translator.tr(this.days[dayIdx]));
        	subnode.setTarget("goto:"+this.menuService.getCurrentNode().getIdentifier());
        	subnode.setOnConfirmAction('copy.timeframes['+this.table+","+this.zone+","+this.day+'].timeframes['+this.table+","+this.zone+","+dayIdx+"]");
        	node.addChild(subnode);
        	this.debugOut("Setting target : "+"goto:"+this.menuService.getCurrentNode().getIdentifier());

        }
        this.menuElements.push(node);
    
        


        this.currentElement = this.menuElements[0];
    }
    ngOnDestroy(){
        this.debugOut("onDestroy");
        if(this.eventSubscription){
            this.eventSubscription.unsubscribe();    
        }
    }
}
